import Vue from "vue";
import VueI18n from "vue-i18n";
Vue.use(VueI18n);

const messages = {
  en: {
    vervideo: "view video",
    error404: "Parece que la página que estás buscando no existe"

  },
  es: {
    vervideo: "ver vídeo",
    error404: "Parece que la página que estás buscando no existe"
  },
  br: {
    vervideo: "view video",
    error404: "Parece que la página que estás buscando no existe"
  }
};

const i18n = new VueI18n({
  locale: "en",
  fallbackLocale: "es",
  messages
});

export default i18n;
